import React, { FC } from 'react'

import { ProgressCircle } from 'Components/ProgressCircle/ProgressCircle'
import { Nutritions, UserSettingsValue } from 'Models'
import { Calculator, Formatter } from 'Utils'

export type CockpitProps = {
  isLoading: boolean
  /** sum of all direct energy records in kcal */
  acceptedDirectEnergyIntake: number
  goalEnergy: number
  /** sum of all searched meal energy in kcal */
  acceptedNutritions?: Nutritions
  goalNutritions?: Nutritions
  acceptedEnergyMotionSum: number
  activityCompensationPercentage?: UserSettingsValue
}

const getCockpitEnergyDerived = (props: CockpitProps): { acceptedEnergySum: number; remainingEnergy: number } => {
  const {
    acceptedNutritions,
    acceptedDirectEnergyIntake,
    goalEnergy,
    acceptedEnergyMotionSum,
    activityCompensationPercentage
  } = props

  const acceptedEnergySum = ((acceptedNutritions && acceptedNutritions.energy) || 0) + acceptedDirectEnergyIntake

  const remainingEnergy =
    goalEnergy -
    acceptedEnergySum +
    (activityCompensationPercentage !== undefined
      ? (acceptedEnergyMotionSum / 100) * Number(activityCompensationPercentage)
      : acceptedEnergyMotionSum)

  return { acceptedEnergySum, remainingEnergy }
}

const formatKcal = (energy: number): string => Formatter.formatEnergy(energy, false)

export const Cockpit: FC<CockpitProps> = (props) => {
  const { isLoading, acceptedNutritions, goalNutritions, goalEnergy, acceptedEnergyMotionSum } = props
  const { acceptedEnergySum, remainingEnergy } = getCockpitEnergyDerived(props)

  const progressLeft =
    Math.min(Calculator.calculatePercentage(acceptedEnergySum, goalEnergy + acceptedEnergyMotionSum), 1) * 100

  return (
    <>
      <section className="standardcard mb-2 cockpit-card">
        {isLoading ? (
          <ProgressCircle loading />
        ) : (
          <ProgressCircle
            topItem={{
              label: (
                <>
                  VERBLEIBENDE
                  <br />
                  KCAL
                </>
              ),
              value: formatKcal(remainingEnergy)
            }}
            leftItem={{
              label: 'Gegessen',
              value: formatKcal(acceptedEnergySum)
            }}
            rightItem={{
              label: 'Aktivität',
              value: formatKcal(acceptedEnergyMotionSum)
            }}
            progressLeft={progressLeft}
          />
        )}
      </section>
    </>
  )
}
